<template>
  <div class="d-flex flex-column gap-5 align-items-center w-100 p-3">
    <div style="height: 150px; background-color: #056331;" class="mx-5 w-100 d-flex align-items-center justify-content-center rounded-3">
      <h1 class="text-white">{{ $t('Exportadores') }}</h1>
    </div>
    <div v-if="hasDatosPersonalesPermission" class="mx-5 container d-flex flex-column">
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4">
        <p>Exportador de Datos Personales</p>
      </div>
      <div class="d-flex flex-row gap-2">
        <button @click="downloadCsv" class="btn btn-primary">Descargar CSV</button>
        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="../assets/LOADING.gif" style="width: 30px;" alt="Cargando..." />
        </div>
      </div>
    </div>
    <form v-if="hasComedorPermission" @submit.prevent class="d-flex flex-column gap-2 container">
      <div class="d-flex align-items-center">
        <p class="m-0">Reporte Semanal Comedor</p>
        <a v-if="hasVerDocumentacionPermission" href="https://docs.google.com/document/d/1_5XatTIwG1hfPz4mXMXh2ipVf8O2IyM8rcrYymv8M24/edit?usp=sharing"
          class="d-flex flex-row text-decoration-none align-items-center justify-content-start m-1 px-1" target="_blank">
          <p class="m-0 fs-6 texto-secundario">•  {{ $t('documentacion') }}</p>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-secundario" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
      <div class="select-wrapper position-relative" style="max-width: 250px;">
        <select v-model="nivel" class="form-select fondo-terciario sombra-sm" required>
          <option value="ADM">{{ $t('administracion') }}</option>
          <option value="KG">{{ $t('jardin') }}</option>
          <option value="EP">{{ $t('primaria') }}</option>
          <option value="ES">{{ $t('secundaria') }}</option>
          <option value="MANT">{{ $t('mantenimiento') }}</option>
          <option value="DEP">{{ $t('deporte') }}</option>
          <!-- <option value="JER">{{ $t('jerarquicos') }}</option> -->
        </select>
        <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
        </svg>
      </div>
      
      <div class="select-wrapper position-relative" style="max-width: 250px;">
        <select v-model="diaSeleccionado" class="form-select fondo-terciario sombra-sm" required>
          <option value="" disabled>Seleccione una semana (Lunes)</option>
          <option v-for="lunes in listaLunes" :key="lunes.value" :value="lunes.value">
            Semana del lunes {{ lunes.label }}
          </option>
        </select>
        <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
        </svg>
      </div>

      <div class="d-flex flex-row gap-2">
        <button @click="downloadReporteComedor" class="btn btn-success">Descargar Reporte PDF</button>
        <div v-if="loadingComedor" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="../assets/LOADING.gif" style="width: 30px;" alt="Cargando..." />
        </div>
      </div>
    </form>
  </div>
</template>


<script>
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import api from '@/services/api';
  //import { databaseUnavailable } from '@azure/msal-browser/dist/error/BrowserAuthErrorCodes';

export default {
  name: "ExportadoresPage",
  setup() {
    const store = useStore();
    const user = computed(() => store.state.user);
    const router = useRouter();
    const loading = ref(false);
    const loadingComedor = ref(false);
    const nivel = ref('');
    const listaLunes = ref([]);
    const diaSeleccionado = ref('');

    const checkAuth = async () => {
      var permisoAComprobar = 'Exportador'
      if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso.includes(permisoAComprobar)) || 
        user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso.includes(permisoAComprobar))))
      {
        console.log("Tiene Permiso");
      }
      else{
        console.log('Usuario no tiene permiso a acceder.');
        await router.push('/');
      }
    };

    
    const hasDatosPersonalesPermission = computed(() => {
      if (user.value) {
        var permisoAComprobar = 'ExportadorDatosPersonales'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          return true;
        }
      }
      return false;
    });

    
    const hasComedorPermission = computed(() => {
      if (user.value) {
        var permisoAComprobar = 'ExportadorComedor'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          return true;
        }
      }
      return false;
    });

    
    const hasVerDocumentacionPermission = computed(() => {
      if (user.value) {
        var permisoAComprobar = 'VerDocumentacion'
        if (user.value.personasPermisos?.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles?.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          return true;
        }
      }
      return false;
    });

    // Función para generar 6 lunes: el de esta semana y 5 anteriores
    const generarListaLunes = () => {
      const lunesArray = [];
      
      // 1. Encontrar el lunes de la SEMANA ACTUAL
      let actual = new Date();
      const diff = actual.getDay() === 0 ? 6 : actual.getDay() - 1;
      actual.setDate(actual.getDate() - diff);

      // 2. Retroceder una semana para empezar desde el "Lunes Anterior"
      actual.setDate(actual.getDate() - 7);

      // 3. Generar 5 lunes hacia adelante (el anterior, el actual y 3 futuros)
      for (let i = 0; i < 5; i++) {
        const fechaCopia = new Date(actual);
        
        // Formato YYYY-MM-DD para la API
        const year = fechaCopia.getFullYear();
        const month = String(fechaCopia.getMonth() + 1).padStart(2, '0');
        const day = String(fechaCopia.getDate()).padStart(2, '0');
        const value = `${year}-${month}-${day}`;
        
        // Formato DD/MM/YYYY para el usuario
        const label = fechaCopia.toLocaleDateString('es-AR', {
          day: '2-digit',
          month: '2-digit'
        });
        
        lunesArray.push({ value, label });
        
        // SUMAR 7 días para ir al siguiente lunes
        actual.setDate(actual.getDate() + 7);
      }

      listaLunes.value = lunesArray;
      
      // 4. Seleccionar por defecto el segundo elemento (que sería el lunes de ESTA semana)
      if (lunesArray.length > 1) {
        diaSeleccionado.value = lunesArray[1].value;
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      generarListaLunes();
    });

    // Función para descargar el archivo CSV
    const downloadCsv = async () => {
      loading.value = true;  // Mostrar el spinner de carga

      try {
        // Hacer la solicitud para obtener los datos CSV desde la API
        const response = await api.get(`api/Persona/ExportarPersonasCSV`, {
          responseType: 'blob',  // Asegurarse de que el contenido sea tratado como un archivo binario
        });

        // Crear un enlace para descargar el archivo CSV
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data.csv');  // Nombre del archivo a descargar
        document.body.appendChild(link);
        link.click();  // Simular clic en el enlace para iniciar la descarga
        link.remove();
      } catch (error) {
        console.error("Error al descargar el archivo CSV:", error);
      } finally {
        loading.value = false;  // Ocultar el spinner de carga
      }
    };

    

    // Función para descargar el archivo CSV
    const downloadReporteComedor = async () => {
      loadingComedor.value = true;
      try {
        const response = await api({ // Usamos tu instancia 'api'
          method: 'post',
          url: `api/comedor/reporte-semanal-2?nivel=${nivel.value}&fecha=${diaSeleccionado.value}`,
          responseType: 'blob',
          headers: {
            'Accept': 'application/pdf'
          }
        });
        // Intentamos obtener el header 'content-disposition' para extraer el nombre del archivo sugerido por el backend
        const disposition = response.headers['content-disposition'] 

        let fileName = `Comedor_${nivel.value}.pdf`;

        if (disposition) {
          // Regex mejorada para capturar el nombre entre comillas o simple
          const match = disposition.match(/filename=(["']?)(.*?[^\\])\1(?:;|$)/);
          if (match && match[2]) {
            fileName = match[2];
          }
        }

        saveFile(response.data, fileName);
      } catch (error) {
        console.error("Error al descargar el reporte PDF:", error);
      } finally {
        loadingComedor.value = false;
      }
    };

    const saveFile = (data, fileName) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    };

    
    // Función para descargar el archivo CSV
    const downloadCsvForm = async () => {
      loading.value = true;  // Mostrar el spinner de carga

      try {
        // Hacer la solicitud para obtener los datos CSV desde la API
        const response = await api.get(`api/Formularios/ExcelResults`, {
          params: {
            id: '8b638018-e8f3-4540-8f3d-8054b95ed532',
          },
          responseType: 'blob',  // Asegurarse de que el contenido sea tratado como un archivo binario
        });

        // Crear un enlace para descargar el archivo CSV
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'dataForm.csv');  // Nombre del archivo a descargar
        document.body.appendChild(link);
        link.click();  // Simular clic en el enlace para iniciar la descarga
        link.remove();
      } catch (error) {
        console.error("Error al descargar el archivo CSV:", error);
      } finally {
        loading.value = false;  // Ocultar el spinner de carga
      }
    };

    return {
      loading,
      loadingComedor,
      nivel,
      downloadCsv,
      downloadCsvForm,
      downloadReporteComedor,
      listaLunes,
      diaSeleccionado,
      hasDatosPersonalesPermission,
      hasComedorPermission,
      hasVerDocumentacionPermission,
    };
  }
};
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.card-body h3 {
  font-size: 50px;
  color: #056331;
}
</style>
